import React, { useEffect, useState } from 'react';

export enum ListViewMode {
  PAGE = 'PAGE',
  GRID = 'GRID',
}

export interface StepStoryBuilderProps {
  mode: ListViewMode;
  setMode: (mode: ListViewMode) => void;
  colorIcon?: string;
  colorActiveIcon?: string;
  colorBackground?: string;
  showAfterScrollPosition?: number;
}

const ListViewModeSwitcher = ({
                                setMode,
                                mode,
                                colorIcon = '#4AA8AF',
                                colorActiveIcon = '#4AA8AF',
                                colorBackground = '#4AA8AF33',
                                showAfterScrollPosition = -1
                              }: StepStoryBuilderProps) => {
  const [isShow, setIsShow] = useState<boolean>(showAfterScrollPosition === -1);

  useEffect(() => {
    if (showAfterScrollPosition === -1) {
      return;
    }
    const handleScroll = () => {
      console.log(window.scrollY, isShow);
      if (window.scrollY >= showAfterScrollPosition && !isShow) {
        setIsShow(true);
      } else if (window.scrollY < showAfterScrollPosition && isShow) {
        setIsShow(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [isShow]);
  return (
    <>
      {isShow && (
        <div className="flex items-center space-x-4">
          <button
            onClick={() => setMode(ListViewMode.PAGE)}
            aria-label="page"
            title="Switch to Page view"
            className={`hover:opacity-80 transition-opacity rounded-full p-2 hover:bg-${colorBackground} hover:bg-opacity-10 ${mode === ListViewMode.PAGE && `bg-${colorBackground} bg-opacity-70`}`}
          >
            <svg style={{ color: mode === ListViewMode.PAGE ? colorActiveIcon : colorIcon }} width="24" height="24"
                 viewBox="0 0 24 24" fill="none"
                 xmlns="http://www.w3.org/2000/svg">
              <path
                d="M3 15L21 15M7.8 3L16.2 3C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8L21 16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21L7.8 21C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2L3 7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3Z"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </button>
          <button
            onClick={() => setMode(ListViewMode.GRID)}
            aria-label="grid"
            title="Switch to Grid view"
            className={`hover:opacity-80 transition-opacity rounded-full p-2 hover:bg-${colorBackground} hover:bg-opacity-10 ${mode === ListViewMode.GRID && `bg-${colorBackground} bg-opacity-70`}`}
          >
            <svg style={{ color: mode === ListViewMode.GRID ? colorActiveIcon : colorIcon }} width="24" height="24"
                 viewBox="0 0 24 24" fill="none"
                 xmlns="http://www.w3.org/2000/svg">
              <path
                d="M8.4 3H4.6C4.03995 3 3.75992 3 3.54601 3.10899C3.35785 3.20487 3.20487 3.35785 3.10899 3.54601C3 3.75992 3 4.03995 3 4.6V8.4C3 8.96005 3 9.24008 3.10899 9.45399C3.20487 9.64215 3.35785 9.79513 3.54601 9.89101C3.75992 10 4.03995 10 4.6 10H8.4C8.96005 10 9.24008 10 9.45399 9.89101C9.64215 9.79513 9.79513 9.64215 9.89101 9.45399C10 9.24008 10 8.96005 10 8.4V4.6C10 4.03995 10 3.75992 9.89101 3.54601C9.79513 3.35785 9.64215 3.20487 9.45399 3.10899C9.24008 3 8.96005 3 8.4 3Z"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              <path
                d="M19.4 3H15.6C15.0399 3 14.7599 3 14.546 3.10899C14.3578 3.20487 14.2049 3.35785 14.109 3.54601C14 3.75992 14 4.03995 14 4.6V8.4C14 8.96005 14 9.24008 14.109 9.45399C14.2049 9.64215 14.3578 9.79513 14.546 9.89101C14.7599 10 15.0399 10 15.6 10H19.4C19.9601 10 20.2401 10 20.454 9.89101C20.6422 9.79513 20.7951 9.64215 20.891 9.45399C21 9.24008 21 8.96005 21 8.4V4.6C21 4.03995 21 3.75992 20.891 3.54601C20.7951 3.35785 20.6422 3.20487 20.454 3.10899C20.2401 3 19.9601 3 19.4 3Z"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              <path
                d="M19.4 14H15.6C15.0399 14 14.7599 14 14.546 14.109C14.3578 14.2049 14.2049 14.3578 14.109 14.546C14 14.7599 14 15.0399 14 15.6V19.4C14 19.9601 14 20.2401 14.109 20.454C14.2049 20.6422 14.3578 20.7951 14.546 20.891C14.7599 21 15.0399 21 15.6 21H19.4C19.9601 21 20.2401 21 20.454 20.891C20.6422 20.7951 20.7951 20.6422 20.891 20.454C21 20.2401 21 19.9601 21 19.4V15.6C21 15.0399 21 14.7599 20.891 14.546C20.7951 14.3578 20.6422 14.2049 20.454 14.109C20.2401 14 19.9601 14 19.4 14Z"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              <path
                d="M8.4 14H4.6C4.03995 14 3.75992 14 3.54601 14.109C3.35785 14.2049 3.20487 14.3578 3.10899 14.546C3 14.7599 3 15.0399 3 15.6V19.4C3 19.9601 3 20.2401 3.10899 20.454C3.20487 20.6422 3.35785 20.7951 3.54601 20.891C3.75992 21 4.03995 21 4.6 21H8.4C8.96005 21 9.24008 21 9.45399 20.891C9.64215 20.7951 9.79513 20.6422 9.89101 20.454C10 20.2401 10 19.9601 10 19.4V15.6C10 15.0399 10 14.7599 9.89101 14.546C9.79513 14.3578 9.64215 14.2049 9.45399 14.109C9.24008 14 8.96005 14 8.4 14Z"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </button>
        </div>
      )}
    </>
  );
};

export default ListViewModeSwitcher;